export function inferSourceKind(name = '', mimeType = '') {
  const lowerName = String(name || '').toLowerCase();
  const lowerMime = String(mimeType || '').toLowerCase();

  const kindRules = [
    {
      matches: [
        lowerMime.includes('msword'),
        lowerMime.includes('officedocument.wordprocessingml'),
        lowerName.endsWith('.doc'),
        lowerName.endsWith('.docx'),
      ],
      kind: 'word',
    },
    { matches: [lowerMime.includes('pdf'), lowerName.endsWith('.pdf')], kind: 'pdf' },
    { matches: [lowerMime.startsWith('image/'), /\.(png|jpg|jpeg|gif|webp|bmp|svg)$/.test(lowerName)], kind: 'image' },
  ];
  return kindRules.find(({ matches }) => matches.some(Boolean))?.kind ?? 'file';
}

export function getSourceTypeLabel(kind) {
  if (kind === 'word') {
    return 'Word 文档';
  }
  if (kind === 'pdf') {
    return 'PDF 文档';
  }
  if (kind === 'image') {
    return '图片';
  }
  return '文件';
}

export function getSourceDisplayName(source = {}, fallback = '') {
  const profileCandidate = source.document_profile;
  const profile = [
    Boolean(profileCandidate),
    typeof profileCandidate === 'object',
    !Array.isArray(profileCandidate),
  ].every(Boolean) ? profileCandidate : {};
  return String([profile.display_name, source.filename, source.name, fallback].find(Boolean) ?? '').trim();
}

export function getMaterialStatusLabel(status) {
  const normalizedStatus = String(status || '').trim().toLowerCase();
  if (normalizedStatus === 'uploading') {
    return '上传中';
  }
  if (['processing', 'uploaded', 'parsing', 'chunked', 'embedded', 'indexed'].includes(normalizedStatus)) {
    return '处理中';
  }
  if (['failed', 'error'].includes(normalizedStatus)) {
    return '处理失败';
  }
  if (normalizedStatus === 'duplicate') {
    return '重复资料';
  }
  return '可用于上下文';
}

export function getMaterialScopeLabel(scope) {
  return String(scope || '').trim().toLowerCase() === 'message' ? '会话附件' : '项目资料';
}

export function getMaterialSourceLabel(source) {
  const normalizedSource = String(source || '').trim().toLowerCase();
  if (normalizedSource === 'mcp') {
    return 'MCP';
  }
  if (normalizedSource === 'external_connector') {
    return '外部连接器';
  }
  return '本地上传';
}

export function formatMaterialSize(size) {
  if (!Number.isFinite(size) || size <= 0) {
    return '-';
  }
  if (size < 1024) {
    return `${size} B`;
  }
  if (size < 1024 * 1024) {
    return `${(size / 1024).toFixed(1)} KB`;
  }
  return `${(size / (1024 * 1024)).toFixed(1)} MB`;
}

export function isMaterialFailedStatus(status) {
  const normalizedStatus = String(status || '').trim().toLowerCase();
  return normalizedStatus === 'failed' || normalizedStatus === 'error';
}
